class HeroOne {
    constructor() {
        this.context = null;
        this.pageActive = {};
        this.videoBg = {};
        this.videoBgReady = {};
        this.setBg();
    }

    start(page) {
        this.pageActive[page] = true;
        this[page]();
        this.context.removeClass('animate-out');
    }

    reset(page) {
        this.pageActive[page] = false;
        this.context.removeClass('animate-in');
        this.context.addClass('animate-out');
        this.context.find('.active').removeClass('active');
        setTimeout(() => {
            if (!this.pageActive[page]) {
                this.videoBg[page] && this.videoBg[page].stop();
            }
        }, 1000);
    }

    heroOne1() {
        this.context = $('.section-page__hero1');
        this.context.addClass('animate-in');
        this.context.find('.obj2-1-tit').addClass('active');
        this.context.find('.obj2-1-txt1').addClass('active');
        this.context.find('.obj2-1-txt2').addClass('active');
        this.context.find('.obj2-1-box1').addClass('active');
        this.context.find('.obj2-1-chr1').addClass('active');

        this.playBg('HeroOne1');
    }
    setBg() {
        this.videoBg.HeroOne1 = new nc.ui.Player({
            selector: '#bg-video-hero1',
            videoId: 'http://vodfile.ncsoft.co.kr/ncvod/plaync/BNS/fd/bimuhero_high.mp4',
            mute: true,
            autoPlay: false,
            loop: true
        });
    }
    playBg(id) {
        if (this.videoBgReady[id]) {
            this.videoBg[id].play();
        }

        let checkReady = setInterval(() => {
            this.videoBgReady[id] = this.videoBg[id].player.state.isReady;
            if (this.videoBgReady[id]) {
                this.videoBg[id].play();
                clearInterval(checkReady);
            }
        }, 100);
    }
}

export default HeroOne;


// WEBPACK FOOTER //
// ./history/2017/171206_flamedragon/_src/js/page/heroOne.js